import { Divider, Typography, Avatar } from "antd";
import { useHistory } from "react-router-dom";
import LinesSkeleton from "./LinesSkeleton";
const { Text, Title } = Typography;

const FabricFilter = ({
  setIsDenim,
  isDenim,
  colors,
  colorsIsLoading,
  elasticityIsLoading,
  elasticity,
  weightIsLoading,
  weight,
  fiberIsLoading,
  fibers,
  checkboxChange,
  queryFabricType,
  compositionsIsLoading,
  compositions,
}: any) => {
  const history = useHistory();

  const showElasticities = () => {
    let rigid = elasticity.find((el: any) => el.name === "Rigid");
    let comfort = elasticity.find((el: any) => el.name === "Comfort");
    let stretch = elasticity.find((el: any) => el.name === "Stretch");
    let powStretch = elasticity.find((el: any) => el.name === "Power Stretch");
    let hyperStretch = elasticity.find(
      (el: any) => el.name === "Hyper Stretch"
    );
    return [rigid, comfort, stretch, powStretch, hyperStretch].map(
      (el: any) => (
        <div
          className="d-flex align-items-center justify-content-between my-2"
          key={el.id}
        >
          <Text>{el.name}</Text>
          <input
            type="checkbox"
            className="filter_checkbox"
            id="elasticity"
            name="elasticities"
            onChange={({ target }: any) =>
              checkboxChange(target.name, el.id, target.checked)
            }
          />
        </div>
      )
    );
  };

  return (
    <div>
      <div className="my-4">
        <p className="underlined-item"></p>
        <p className="underlined-item"></p>
        <div>
          <Text
            underline={queryFabricType === "denim"}
            strong={queryFabricType === "denim"}
            //@ts-ignore
            onClick={() => {
              setIsDenim(true);
              history.push("/library?fabric_type=denim&page=1");
            }}
            style={{
              color: queryFabricType === "denim" ? "#0060c0" : "inherit",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            DENIM
          </Text>
        </div>
        <div>
          <Text
            underline={queryFabricType === "knit"}
            strong={queryFabricType === "knit"}
            //@ts-ignore
            onClick={() => {
              setIsDenim(false);
              history.push("/library?fabric_type=knit&page=1");
            }}
            style={{
              color: queryFabricType === "knit" ? "#0060c0" : "inherit",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            KNIT
          </Text>
        </div>
      </div>
      <Divider />
      <div>
        <Title level={4}>Color</Title>
        {colorsIsLoading ? (
          <LinesSkeleton />
        ) : (
          colors
            .filter((color: any) => color.fabric_type === queryFabricType)
            .filter((color: any) =>
              queryFabricType === "denim"
                ? color.name === "Light Blue" ||
                  color.name === "Medium Blue" ||
                  color.name === "Dark Blue" ||
                  color.name === "Black & Grey" ||
                  color.name === "Black Black" ||
                  color.name === "RTD" ||
                  color.name === "Jacquard" ||
                  color.name === "Garment Dye" ||
                  color.name === "Overdyed"
                : color.name === "INDIGO" ||
                  color.name === "RTD" ||
                  color.name === "Raw"
            )
            .map((el: any) => (
              <div
                className="d-flex align-items-center justify-content-between my-2"
                key={el.id}
              >
                <div>
                  <Avatar
                    src={process.env.REACT_APP_STORAGE_URL + el.image}
                    className="mr-2"
                    size="small"
                  />
                  <Text>{el.name}</Text>
                </div>
                <input
                  type="checkbox"
                  className="filter_checkbox"
                  id="color"
                  name="colors"
                  onChange={({ target }: any) =>
                    checkboxChange(target.name, el.id, target.checked)
                  }
                />
              </div>
            ))
        )}
        {queryFabricType === "denim" && (
          <>
            <Divider />
            <Title level={4}>Elasticity</Title>
            {elasticityIsLoading ? (
              <LinesSkeleton />
            ) : (
              showElasticities()
              // .map((el: any) => (
              //   <div
              //     className="d-flex align-items-center justify-content-between my-2"
              //     key={el.id}
              //   >
              //     <Text>{el.name}</Text>
              //     <input
              //       type="checkbox"
              //       className="filter_checkbox"
              //       id="elasticity"
              //       name="elasticities"
              //       onChange={({ target }: any) =>
              //         checkboxChange(target.name, el.id, target.checked)
              //       }
              //     />
              //   </div>
              // ))
            )}
          </>
        )}
        <Divider />
        <Title level={4}>Weight</Title>
        {weightIsLoading ? (
          <LinesSkeleton />
        ) : (
          weight
            .filter((color: any) => color.fabric_type === queryFabricType)
            .map((el: any) => (
              <div
                className="d-flex align-items-center justify-content-between my-2"
                key={el.id}
              >
                <Text>{el.name}</Text>
                <input
                  type="checkbox"
                  className="filter_checkbox"
                  id="weight"
                  name="weights"
                  onChange={({ target }: any) =>
                    checkboxChange(target.name, el.id, target.checked)
                  }
                />
              </div>
            ))
        )}
        {/* {queryFabricType === "denim" && (
          <>
            <Divider />
            <Title level={4}>Fibers</Title>
            {fiberIsLoading ? (
              <LinesSkeleton />
            ) : (
              fibers.map((el: any) => (
                <div
                  className="d-flex align-items-center justify-content-between my-2"
                  key={el.id}
                >
                  <Text>{el.name}</Text>
                  <input
                    type="checkbox"
                    className="filter_checkbox"
                    id="fibers"
                    name="fibers"
                    onChange={({ target }: any) =>
                      checkboxChange(target.name, el.id, target.checked)
                    }
                  />
                </div>
              ))
            )}
          </>
        )} */}
        {/* {queryFabricType === "knit" && ( */}
        <>
          <Divider />
          <Title level={4}>Compositions</Title>
          {compositionsIsLoading ? (
            <LinesSkeleton />
          ) : (
            compositions.map((el: any) => (
              <div
                className="d-flex align-items-center justify-content-between my-2"
                key={el.id}
              >
                <Text>{el.name}</Text>
                <input
                  type="checkbox"
                  className="filter_checkbox"
                  id="fibers"
                  name="fibers"
                  onChange={({ target }: any) =>
                    checkboxChange(target.name, el.id, target.checked)
                  }
                />
              </div>
            ))
          )}{" "}
        </>
        {/* )} */}
      </div>
    </div>
  );
};

export default FabricFilter;
